import { useGetIHFCredentialsMutation } from '../redux/api/userApi'
import { useMultisiteIHFCredentialsMutation } from '../redux/api/authApi'
import { useSelector } from 'react-redux'
import { LINKS } from '../utils/constants/links'

export const useIHFlink = (xsrf: string) => {
  const [getCredentials, { isLoading: isCredentialsLoading }] = useGetIHFCredentialsMutation()
  const [getMultisiteIHFCredentials, { isLoading: isMultisiteLoading }
  ] = useMultisiteIHFCredentialsMutation()

  const mode = useSelector((state: any) => state.modeState)
  const open = () => {
    if (mode.isWp) {
      const root = document.getElementById('root')
      const bearerToken = root?.getAttribute('data-auth-token')
      getMultisiteIHFCredentials({ bearerToken }).then((response) => {
        if ('data' in response) {
          window.open(LINKS.IHF_DASHBOARD(response.data.username, response.data.password))
        }
      }).catch((e) => { console.log('err', e) })
    } else {
      getCredentials(xsrf).then((response) => {
        if ('data' in response) {
          window.open(LINKS.IHF_DASHBOARD(response.data.username, response.data.password))
        }
      }).catch((e) => { console.log('err', e) })
    }
  }

  const isLoading = mode.isWp ? isMultisiteLoading : isCredentialsLoading

  return {
    openIHFDashboard: open,
    isLoading
  }
}

export default useIHFlink
